import { connect } from 'react-redux';
import { Map } from 'immutable';

import decorate from '../../../../utils/decorate';

import { request } from '../../../../modules/customers/actions/update';
import { request as checkCurrencyValidation } from '../../../../modules/customers/actions/currency-validation';
import { request as checkReferalValidation } from '../../../../modules/customers/actions/referal-validation';
import { request as langRequest } from '../../../../modules/languages/actions/find';
import CustomerSettingsTab from './CustomerSettingsTab';

function mapStateToProps(state, props) {
    const id = parseInt(props.id, 10);
    let langs = state.languages.get('data') && state.languages.get('data').get('list');
    let update = state.customers.get('update').get(id) || Map();
    const validations = state.customers.get('validations') || Map();

    return {
        status: update.get('state'),
        errors: update.get('errors'),
        customer: state.customers.get('list').get(id) || Map(),

        referal: validations.getIn([ 'referal', id ]) || Map(),
        currency: validations.getIn([ 'currency', id ]) || Map(),
        languages: langs || Map()
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onUpdateRequest: (id, data) => dispatch(request(id, data)),
        onLangRequest: () => dispatch(langRequest()),
        onCheckCurrencyValidation: (customerId) => dispatch(checkCurrencyValidation(customerId)),
        onCheckReferalValidation: (customerId) => dispatch(checkReferalValidation(customerId))
    };
}

export default decorate(
    connect(mapStateToProps, mapDispatchToProps),
    CustomerSettingsTab
);
